module.exports = __webpack_public_path__ + "i18n/zh-CN.82d1a57c484dcff4521c8c5d946ef9fe.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-CN.json
// module id = 1068
// module chunks = 60